export const locale = {
    lang: 'ds',
    data: {
        'Header':{
            'Changeshifthours': 'Skift skifttid'
        },
        'FIELDS': {
            'Name': 'Name',
            'Questions': 'Spørgsmål',
            'SrNo': 'Sr nr.',
            'Status': 'Status',
            'Body':'Legeme',
            'All':'Alle dage'
        },
        'MESSAGES': {
            'Success': 'SMS is sent successfully',
            'Failed': 'Failed',
          'NORECORD': 'Intet Spørgsmål fundet',
          'SAVESUCCESSFULLY': 'Gem med succes.'
        },
        'BUTTONS': {
            'SMS': 'SMS',
            'Email': 'Email',
            'SMSEmail': 'SMS og e-mail',
            'None': 'Ingen',
            'Save': 'Gem',
            'Back': 'Tilbage'
        },
        'VALIDATIONS': {
            'Mobile': 'Mobile number is required.',
            'Text': 'Text is required.'
        },
    }
};
